/**
 * Created by tdunham on 6/30/2017.
 */


export class Team {


	public id:              number;     // The ID of the team in the Angular ReST API.
	public title:           string;     // The team name. ("Arizona Cardinals")
	public shorttitle:      string;     // The abbreviated team name. ("Cardinals")
	public code:            string;     // The abbreviated league name. ("NFL")
	public teamcode:        string;     // The matching code for the team ("ARI")
	public conference:      string;     // The conference the team plays in.
	public division:        string;     // The division the team plays in.
	public leagueid:        number;     // The ID number of the league the team plays in from the "team_league" table.


	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

}


// WEBPACK FOOTER //
// ./src/app/services/team/team.ts